const LocalHelper = {

    methods: {

        tasksJoining(array_tasks)
        {
            return array_tasks.join(', ')
        },

        format_open(value)
        {
            let boolean_string = ''
            value ? boolean_string = 'Closed' : boolean_string = 'Open'
            return boolean_string
        },

        async get_next_walking_number(area_id)
        {
            let http_request = {
                request_id:     null,
                levels_request: false,
                areas_request:  false,
                next_walking_number: true,
                area_id,
            }

            const rest_api = 'rooms'
            const response = await this.get(`${rest_api}/${JSON.stringify(http_request)}`)
            this.next_walking_number = response.data.next_walking_number
        },

        async get_child_next_walking_number(room_id, area_id)
        {
            let http_request = {
                room_id,
                child_next_walking_number: true,
                area_id,
            }
            const rest_api = 'rooms'
            const response = await this.get(`${rest_api}/${JSON.stringify(http_request)}`)
            this.child_next_walking_number = response.data.child_next_walking_number
        }

    }

}

export default LocalHelper